<template>
  <div :class="[`${direction}Input`]">
    <span v-if="name" id="inputTitle">
      {{ name }}
    </span>

    <v-select
      id="searchSelect"
      v-model="selected"
      :options="options"
      :label="label"
      :disabled="disabled"
      :clearable="clearable"
      @input="onChange"
      @change="onChange"
    ></v-select>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css'

export default {
  name: 'SearchSelect',
  props: {
    name: {
      type: String,
      default: null
    },

    options: {
      type: Array,
      required: true,
      default: null
    },

    // eslint-disable-next-line vue/require-prop-types
    selectedOption: {
      default: null
    },

    label: {
      type: String,
      default: 'text'
    },

    clearable: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    direction: {
      type: String,
      default: 'horizontal'
    }
  },

  data() {
    return {
      selected: this.selectedOption
    }
  },

  methods: {
    onChange() {
      this.$emit('handleChange', this.selected)
    }
  }
}
</script>

<style lang="scss" scoped>
#inputTitle {
  margin-right: 10px;
}

.horizontalInput {
  display: grid;
  grid-template-columns: 30% 30%;
  margin-left: 5%;
  margin-bottom: 15px;
}
</style>
